import React, { Component, Fragment } from "react";
import Skeleton from "react-loading-skeleton";
import _ from "lodash";
import { Modal, Button, Accordion, Card } from "react-bootstrap";
import { splitAtUpper } from "../../../services/utility/textFormatService";
import { ContextAwareToggle } from "../appraisalPlan/appraisalPlanDetail";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { dataEntryFields as dataEntry } from "./dataEntryFields";
import DetailItem from "../../../components/detailItem";

interface IEmployerListDetailsProps {
    showDetailsModal: boolean;
    toggleDetailsModal: any;
    toggleEditModal: any;
    showTrail: any;
    item: any;
}

interface IEmployerListDetailsState {
    item: any;
    updatingStatus: boolean;
}

class EmployerListDetails extends Component<
    IEmployerListDetailsProps,
    IEmployerListDetailsState
> {
    state = {
        item: {},
        updatingStatus: false,
    };

    static getDerivedStateFromProps(nextProps: IEmployerListDetailsProps, prevState) {
        return {
            item: nextProps.item,
        };
    }

    render() {
        const {
            showDetailsModal,
            toggleDetailsModal,
            toggleEditModal,
            item,
        } = this.props;
        const { updatingStatus } = this.state;

        console.log(item)

        return (
            <Modal
                size="xl"
                backdrop="static"
                show={showDetailsModal}
                onHide={toggleDetailsModal}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {_.isEmpty(item) ? (
                            <Skeleton width={500} />
                        ) : (
                            <h5>
                                <i className="icon icon--columns s-18 mr-3" />
                                Employer Details {": "}
                                <span className="font-weight-bold">{item?.employerName}</span>
                            </h5>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        <div className="card">

                            <Accordion defaultActiveKey="0">
                                <Card>
                                    <ContextAwareToggle
                                        eventKey={`0`}
                                        header={
                                            <React.Fragment>
                                                <i
                                                    className="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    style={{ color: "#878a8a" }}
                                                ></i>{" "}
                                                {item?.employerName}{": "} Details
                                            </React.Fragment>
                                        }
                                    ></ContextAwareToggle>
                                    <Accordion.Collapse eventKey={`0`}>
                                        <Card.Body>
                                            <div style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        {_.isEmpty(item) ? (
                                                            <div style={{ textAlign: "center", color: "#FE825E" }}>
                                                                No Employer Details Available
                                                            </div>
                                                        ) : (
                                                            <Fragment>
                                                                <dl className="row">

                                                                    <DetailItem
                                                                        label="Phone Number"
                                                                        value={item.PhoneNumber}
                                                                        labelSize={5}
                                                                        valueSize={7}
                                                                    />
                                                                    <DetailItem
                                                                        label="Email Address"
                                                                        value={item.Email}
                                                                        labelSize={5}
                                                                        valueSize={7}
                                                                    />
                                                                    <DetailItem
                                                                        label="Country"
                                                                        value={item.Country}
                                                                        labelSize={5}
                                                                        valueSize={7}
                                                                    />
                                                                    <DetailItem
                                                                        label="State"
                                                                        value={item.State}
                                                                        labelSize={5}
                                                                        valueSize={7}
                                                                    />
                                                                </dl>
                                                            </Fragment>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div>
                    </React.Fragment>
                </Modal.Body >
                <Modal.Footer>
                    {/* {_.isEmpty(item) ? (
                        <Skeleton width={100} count={2} height={30} />
                    ) : (
                        <React.Fragment>
                            <Button
                                size="sm"
                                variant="primary"
                                disabled={updatingStatus}
                                onClick={toggleEditModal}
                            >
                                <i className="far fa-edit mr-3" />
                                Edit
                            </Button>
                        </React.Fragment>
                    )} */}
                    <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={toggleDetailsModal}
                    >
                        <i className="fas fa-times mr-3" />
                        Close
                    </Button>
                </Modal.Footer>
            </Modal >
        );
    }
}

export default EmployerListDetails;
